import { Link } from "@inertiajs/react";
import Steps, { Step } from "@/components/help/Steps";
import Callout from "@/components/help/Callout";
import { Badge } from "@/components/ui/badge";

export default function RefundsViaSquare() {
  return (
    <>
      <p>
        Refunds happen in Square, not in PagePledge. Once Square processes the refund, your donations list updates automatically — you don't have to mark anything as refunded in PagePledge.
      </p>

      <Callout variant="note" title="Why Square, not here?">
        <p>
          Square is where the money actually lives. They've already got a great refund flow — full refunds, partial refunds, the whole thing. Sending you there means you only have to learn one set of buttons, and there's no chance the two systems disagree.
        </p>
      </Callout>

      <h2>How to refund a donation</h2>
      <Steps>
        <Step title="Find the donation in PagePledge">
          <p>
            From your sidebar, click <strong>Donations</strong> and find the donation. Then click <strong>View in Square</strong> — it'll open the same donation in your Square dashboard.
          </p>
        </Step>
        <Step title="Refund it in Square">
          <p>
            Square will walk you through it — full amount or partial. Confirm and you're done.
          </p>
        </Step>
        <Step title="Watch the donation update here">
          <p>
            Within a few seconds, the donation in your PagePledge list will switch to <Badge variant="outline">refunded</Badge> and your school's totals will drop accordingly.
          </p>
        </Step>
        <Step title="Send the donor a quick note">
          <p>
            Square won't email the donor — that's on you. A short message saying "we processed your refund, it'll be back on your card in 5–10 days" goes a long way.
          </p>
        </Step>
      </Steps>

      <h2>A few things to know</h2>
      <p>
        Refunds remove the donation from all your totals — school-wide, classroom, leaderboards. But if a student already crossed the line for a prize because of that donation, they keep the prize. Same goes for school-wide rewards — once unlocked, they don't lock back up. Better to leave a celebration alone than yank it back.
      </p>
      <p>
        Refunds after the campaign has locked still work — they just don't change the final rankings. The dashboard will note something like "Raised: $4,950 — includes $50 refunded after the campaign" so the math is honest.
      </p>
      <p>
        If a donor disputes a charge with their bank instead of asking for a refund, Square handles that for you — you'll get a Square email when it happens, and the donation will update here just like a refund.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/tracking-donations">Tracking donations</Link>.</li>
        <li><Link href="/help/articles/donor-receipts-and-refunds">What donors see</Link>.</li>
      </ul>
    </>
  );
}
